import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import KanbanView from './kanban/KanbanView.vue';
import MessageDispatcher from './message-dispatcher/MessageDispatcher.vue';
import InternalChatView from './internal-chat/InternalChatView.vue';
import DemandRadarView from './demand-radar/DemandRadarView.vue';
import VoiceDashboard from './voice/VoiceDashboard.vue';
import SalesView from './sales/SalesView.vue';
import DashboardAppWrapper from './dashboard-apps/DashboardAppWrapper.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/dashboard_apps/:id'),
          name: 'dashboard_apps_show',
          component: DashboardAppWrapper,
          meta: {
            permissions: ['administrator', 'agent'],
            icon: 'i-lucide-apps',
            label: 'DASHBOARD_APPS',
          },
          props: true,
        },
        {
          path: frontendURL('accounts/:accountId/kanban'),
          name: 'kanban_board',
          component: KanbanView,
          meta: {
            permissions: [
              'administrator',
              'agent',
              'kanban_manage',
              'kanban_view',
            ],
            featureFlag: 'kanban_board',
          },
        },
        {
          path: frontendURL('accounts/:accountId/message-dispatcher'),
          name: 'message_dispatcher',
          component: MessageDispatcher,
          meta: {
            featureFlag: 'message_dispatcher',
            permissions: [
              'administrator',
              'agent',
              'conversation_manage',
              'conversation_unassigned_manage',
              'conversation_participating_manage',
            ],
          },
        },
        {
          path: frontendURL('accounts/:accountId/internal-chat'),
          name: 'internal_chat',
          component: InternalChatView,
          meta: {
            featureFlag: 'internal_chat',
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/demand-radar'),
          name: 'demand_radar',
          component: DemandRadarView,
          meta: {
            featureFlag: 'demand_radar',
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/sales'),
          name: 'sales_dashboard',
          component: SalesView,
          meta: {
            featureFlag: 'sales',
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/voice'),
          name: 'voice_dashboard',
          component: VoiceDashboard,
          meta: {
            featureFlag: 'voice_os',
            permissions: ['administrator', 'agent'],
          },
        },
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
